export default __webpack_public_path__ + "static/media/frametelegram.042387ab.svg";